import React from "react";
import styles from "./styles.css";
import PreApproved from "./images/preapproved.png";
import { useHistory } from "react-router-dom";

const CarFinancePreApprovedBannerRevamp = () => {
    const history = useHistory();
    const handleKnowMore = () => {
        history.push("/cars24-finance");
    };
    return (
        <div styleName={"styles.outer"}>
            <div styleName={"styles.leftWrapper"}>
                <p styleName={"styles.heading"}>You are<br /><span>Pre-approved</span><br />for finance</p>
                <p styleName={"styles.subHeading"} onClick={handleKnowMore}>Know more</p>
            </div>
            <div styleName={"styles.rightWrapper"}>
                <img src={PreApproved} alt="CARS24 Platinum cover" />
            </div>
        </div>
    );
};

export default CarFinancePreApprovedBannerRevamp;
